<template>
  <div class="member-basic">
    <!--面板中的内容-->
    <div class="member-right-inner-bottom">
      <!--标签,类似笔的形状,如果需要使用收起全部的功能,ref必须要写,ref不要使用同一个-->
      <pen-panel
        text="基本信息"
        :closAble="true"
        ref="baseInfo"
        v-loading="loadingData"
      >
        <div class="edit-information" style="padding: 20px" v-if="isShowEdit">
          <el-form :rules="rules" ref="ruleForm" :model="form">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="姓名" prop="name">
                  <el-input
                    v-model="form.name"
                    type="text"
                    placeholder="请输入用户姓名"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别">
                  <el-select
                    v-model="form.gender"
                    placeholder="请选择性别"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生日期">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="form.birth"
                    value-format="yyyy-MM-dd"
                    style="width: 100%;"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="政治面貌">
                  <el-select
                    v-model="form.politicTpCode"
                    placeholder="请选择政治面貌"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in codes['009']"
                      :key="index"
                      :label="item.cdDesc"
                      :value="item.cd"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="职称">
                  <yl-cascader
                    :options="titleTpCodes"
                    @change="handleTitleTpCodeChange"
                    v-model="form.showTitleTpCode"
                    :show-all-levels="false"
                    filterable
                    placeholder="试试搜索：护士，或者选择"
                    clearable
                    style="width: 100%"
                  >
                  </yl-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="第二职称">
                  <yl-cascader
                    :options="secondTpCodes"
                    @change="handleSecondTpCodeChange"
                    v-model="form.showSecondTpCode"
                    :show-all-levels="false"
                    filterable
                    placeholder="试试搜索：护士，或者选择"
                    clearable
                    style="width: 100%"
                  >
                  </yl-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="行政职务">
                  <el-input
                    v-model="form.administrative"
                    placeholder="请输入行政职务"
                    type="text"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="导师类型">
                  <el-select
                    v-model="form.tutorTpCode"
                    placeholder="请选择导师类型"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in codes['011']"
                      :key="index"
                      :label="item.cdDesc"
                      :value="item.cd"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col
                :span="8"
                v-if="
                  form.tutorTpCode === '011-002' ||
                    form.tutorTpCode === '011-003'
                "
              >
                <el-form-item label="导师获得时间">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="form.tutorObtainTime"
                    value-format="yyyy-MM-dd"
                    style="width: 100%;"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="一级研究方向">
                  <el-select
                    v-model="form.directionLv1TpCode"
                    placeholder="请选择一级研究方向"
                    clearable
                    style="width: 100%"
                    @change="chooseLv1Value"
                  >
                    <el-option
                      v-for="(item, index) in codes['012']"
                      :key="index"
                      :label="item.cdDesc"
                      :value="item.cd"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="二级研究方向"
                  prop="directionLv2TpCode"
                  v-if="form.directionLv1TpCode"
                >
                  <el-select
                    v-model="form.directionLv2TpCode"
                    placeholder="请选择二级研究方向"
                    clearable
                    style="width: 100%"
                    @change="chooseLv2Value"
                  >
                    <el-option
                      v-for="(item, index) in codes['013']"
                      :key="index"
                      :label="item.cdDesc"
                      :value="item.cd"
                      v-if="item.parentCd == form.directionLv1TpCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="
                  form.directionLv2TpCode !== null &&
                    form.directionLv2TpCode.length > 7
                "
              >
                <el-form-item label="其他二级方向" prop="directionLv2Desc">
                  <el-input
                    v-model="form.directionLv2Desc"
                    type="text"
                    placeholder="请输入其他二级方向"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号" prop="userId">
                  <el-input
                    v-model="form.userId"
                    type="text"
                    placeholder="请输入手机号"
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="邮箱" prop="mail">
                  <el-input
                    v-model="form.mail"
                    type="text"
                    placeholder="请输入邮箱"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="所属机构" prop="majorDepartId">-->
              <!--                  <yl-cascader-->
              <!--                    :props="{ checkStrictly: true }"-->
              <!--                    class="deptClass"-->
              <!--                    :options="departments"-->
              <!--                    @change="handleDeptChange"-->
              <!--                    v-model="form.departmentId"-->
              <!--                    :show-all-levels="false"-->
              <!--                    filterable-->
              <!--                    style="width: 100%">-->
              <!--                  </yl-cascader>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-col :span="8">
                <el-form-item label="所属机构">
                  <el-input
                    v-model="form.departmentName"
                    type="text"
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="科室">
                  <el-input
                    v-model="form.section"
                    type="text"
                    placeholder="请输入科室"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="微信号">
                  <el-input
                    v-model="form.wechatNumber"
                    type="text"
                    placeholder="请输入微信号"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="证件类型">
                  <el-select
                    v-model="form.idTypeCode"
                    placeholder="请选择证件类型"
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in codes['007']"
                      :key="index"
                      :label="item.cdDesc"
                      :value="item.cd"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="证件号码"
                  prop="idNumber"
                  v-if="form.idTypeCode && form.idTypeCode == '007-001'"
                >
                  <el-input
                    v-model="form.idNumber"
                    type="text"
                    placeholder="请输入身份证号码"
                    clearable
                    @change="getInfo(form.idNumber)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="证件号码"
                  prop="idNumber2"
                  v-if="form.idTypeCode && form.idTypeCode !== '007-001'"
                >
                  <el-input
                    v-model="form.idNumber2"
                    type="text"
                    placeholder="请输入证件号码"
                    clearable
                  ></el-input>
                </el-form-item>
                <!--                <el-form-item label="证件号码" prop="idNumber2" v-if="form.idTypeCode && form.idTypeCode=='007-002'">-->
                <!--                  <el-input v-model="form.idNumber2" type="text" placeholder="请输入证件号码" clearable></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="证件号码" prop="idNumber2" v-if="form.idTypeCode && form.idTypeCode=='007-002'">-->
                <!--                  <el-input v-model="form.idNumber2" type="text" placeholder="请输入证件号码" clearable></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="证件号码" prop="idNumber2" v-if="form.idTypeCode && form.idTypeCode=='007-002'">-->
                <!--                  <el-input v-model="form.idNumber2" type="text" placeholder="请输入证件号码" clearable></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="证件号码" prop="idNumber2" v-if="form.idTypeCode && form.idTypeCode=='007-002'">-->
                <!--                  <el-input v-model="form.idNumber2" type="text" placeholder="请输入证件号码" clearable></el-input>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="证件号码" prop="idNumber2" v-if="form.idTypeCode && form.idTypeCode=='007-002'">-->
                <!--                  <el-input v-model="form.idNumber2" type="text" placeholder="请输入证件号码" clearable></el-input>-->
                <!--                </el-form-item>-->
              </el-col>

              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="民族" >-->
              <!--                  <el-select v-model="form.ethnicityCode" placeholder="请选择民族" clearable style="width: 100%">-->
              <!--                    <el-option label="汉族" value="1"></el-option>-->
              <!--                    <el-option label="壮族" value="2"></el-option>-->
              <!--                  </el-select>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="籍贯">-->
              <!--                  <el-cascader-->
              <!--                    ref="codeCascader"-->
              <!--                    :options="codesTree"-->
              <!--                    popper-class="disableFirstLevel"-->
              <!--                    @change="handleCodeChange"-->
              <!--                    v-model="pCodeAndCCode"-->
              <!--                    placeholder="试试搜索：北京，或者选择"-->
              <!--                    clearable filterable-->
              <!--                    style="width:100%">-->
              <!--                  </el-cascader>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="联系电话（长号）" prop="telNumLong">-->
              <!--                  <el-input v-model="form.telNumLong" type="text" placeholder="请输入联系电话（长号）" clearable></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="8">-->
              <!--                <el-form-item label="联系电话（短号）" prop="telNumShort">-->
              <!--                  <el-input v-model="form.telNumShort" type="text" placeholder="请输入联系电话（短号）" clearable></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
            </el-row>
          </el-form>

          <div class="member-button">
            <button class="save-button" @click="handleSaveClick">保存</button>
            <button class="cancel-button" @click="handleCancelClick">
              取消
            </button>
          </div>
        </div>

        <div
          class="see-information"
          style="padding:40px 20px 20px 20px"
          v-if="isShowSee"
        >
          <el-row>
            <el-col :span="9">
              <span style="font-size: 22px;font-weight: 600">{{
                showData.userName
              }}</span>
              <span style="margin-left: 20px;font-size: 16px">{{
                showData.userId
              }}</span>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" class="span-all">
              <div class="span-left">用户名称：</div>
              <div class="span-right">{{ showData.userName }}</div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">性别：</div>
              <div class="span-right">
                <span v-if="showData.gender == '1'">男</span>
                <span v-else-if="showData.gender == '0'">女</span>
                <span v-else></span>
              </div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">出生日期：</div>
              <div class="span-right">{{ showData.birth | dateFormat }}</div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">政治面貌：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in codes['009']"
                  :key="index"
                  v-if="item.cd == showData.politicTpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">职称：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in [...codes['015'], ...codes['062']]"
                  :key="index"
                  v-show="item.cd == showData.titleTpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>

            <el-col :span="8" class="span-all">
              <div class="span-left">第二职称：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in [...codes['015'], ...codes['062']]"
                  :key="index"
                  v-show="item.cd == showData.secondTpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>

            <el-col :span="8" class="span-all">
              <div class="span-left">行政职务：</div>
              <div class="span-right">{{ showData.administrative }}</div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">导师类型：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in codes['011']"
                  :key="index"
                  v-if="item.cd == showData.tutorTpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>
            <el-col
              :span="8"
              class="span-all"
              v-if="
                showData.tutorTpCode === '011-002' ||
                  showData.tutorTpCode === '011-003'
              "
            >
              <div class="span-left">导师获得时间：</div>
              <div class="span-right">
                {{ showData.tutorObtainTime | dateFormat }}
              </div>
            </el-col>

            <el-col :span="8" class="span-all">
              <div class="span-left">一级研究方向：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in codes['012']"
                  :key="index"
                  v-if="item.cd == showData.directionLv1TpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">二级研究方向：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in codes['013']"
                  :key="index"
                  v-if="item.cd == showData.directionLv2TpCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>
            <el-col
              :span="8"
              class="span-all"
              v-if="
                showData.directionLv2TpCode !== null &&
                  showData.directionLv2TpCode.length > 7
              "
            >
              <div class="span-left">其他二级方向：</div>
              <div class="span-right">
                {{ showData.directionLv2Desc }}
              </div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">手机号：</div>
              <div class="span-right">{{ showData.userId }}</div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">邮箱：</div>
              <div class="span-right">{{ showData.mail }}</div>
            </el-col>
            <el-col :span="8" class="span-all" v-if="showData.tp == '6'">
              <div class="span-left">所属机构：</div>
              <div class="span-right">{{ showData.pname }}</div>
            </el-col>
            <el-col :span="8" class="span-all" v-else>
              <div class="span-left">所属机构：</div>
              <div class="span-right">{{ showData.departmentName }}</div>
            </el-col>
            <el-col :span="8" class="span-all">
              <div class="span-left">科室：</div>
              <div class="span-right">{{ showData.section }}</div>
            </el-col>

            <el-col :span="8" class="span-all">
              <div class="span-left">微信：</div>
              <div class="span-right">{{ showData.wechatNumber }}</div>
            </el-col>

            <el-col :span="8" class="span-all">
              <div class="span-left">证件类型：</div>
              <div class="span-right">
                <span
                  v-for="(item, index) in codes['007']"
                  :key="index"
                  v-show="item.cd == showData.idTypeCode"
                >
                  {{ item.cdDesc }}
                </span>
              </div>
            </el-col>
            <el-col :span="8" class="span-all" v-if="showData.idTypeCode">
              <div class="span-left">证件号：</div>
              <div class="span-right">{{ showData.idNumber }}</div>
            </el-col>
          </el-row>

          <div v-if="editFlag" class="member-button" style="margin-top: 30px">
            <button class="save-button" @click="handleEditClick">编辑</button>
          </div>
        </div>
      </pen-panel>
    </div>
  </div>
</template>

<script>
import defaultLang from "element-ui/lib/locale/lang/zh-CN";
import BasicUpdateInfo from "../../member/BasicUpdateInfo";
import Pen from "../../custom/Pen";
import * as constantsRules from "@/constants/constantRules";
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import { mapState } from "vuex";
import PenPanel from "../../custom/PenPanel";
import { Message } from "element-ui";

export default {
  name: "Basic",
  components: {
    PenPanel,
    Pen,
    BasicUpdateInfo
  },
  props: {
    basicCloseAble: { flag: true }
  },
  data() {
    return {
      elementDeptId: [],
      departments: [], //部门数组
      form: {
        userId: null,
        name: null,
        userName: null,
        gender: null,
        departmentId: null,
        tp: null,
        departmentName: null,
        pid: null,
        pname: null,
        birth: null,
        politicTpCode: null,
        administrative: null,
        titleTpCode: null,
        secondTpCode: null,
        mail: null,
        tutorTpCode: null,
        tutorObtainTime: null,
        directionLv1TpCode: null,
        directionLv2TpCode: null,
        directionLv2Desc: null,
        section: null,
        idTypeCode: null,
        idNumber: null,
        idNumber2: null,
        wechatNumber: null,
        showTitleTpCode: [],
        showSecondTpCode: []
      },
      showData: {
        userId: null,
        userName: null,
        gender: null,
        departmentId: null,
        tp: null,
        departmentName: null,
        pid: null,
        pname: null,
        birth: null,
        politicTpCode: null,
        administrative: null,
        titleTpCode: null,
        secondTpCode: null,
        mail: null,
        tutorTpCode: null,
        tutorObtainTime: null,
        directionLv1TpCode: null,
        directionLv2TpCode: null,
        directionLv2Desc: null,
        section: null,
        idTypeCode: null,
        idNumber: null,
        wechatNumber: null
      },
      //码表
      codes: {},
      titleTpCodes: [],
      secondTpCodes: [],
      isShowEdit: false, //是否展开信息
      isShowSee: true, //是否展开查看信息
      pCodeAndCCode: [], //籍贯的回显值
      loadingData: false,
      rules: constantsRules.BasicInfoRules,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      editFlag: null
    };
  },
  watch: {
    basicCloseAble(newVal) {
      if (newVal.flag === false) {
        for (let that of Object.keys(this.$refs)) {
          this.$refs[that].closAbleHandler(true);
        }
      }
    },
    isShowEdit(newVal) {
      this.$emit("getBasicFlag", newVal);
    },
    "form.idTypeCode"(newVal, oldVal) {
      if (newVal == "007-001") {
        this.form.idNumber = this.form.idNumber;
      } else if (newVal !== "007-001") {
        this.form.idNumber2 = this.form.idNumber;
      } else {
        this.form.idNumber = null;
        this.form.idNumber2 = null;
      }
    }
  },
  mounted() {
    //获取省份码表值
    // this.handlePCodeAndCCode();
    //获取证件类型表值
    // this.handleIdTypeCodes();
    this.editFlag =
      this.$store.state.MemberManageModule.userId == null &&
      !["view", "update"].includes(this.$store.state.MemberManageModule.type)
        ? true
        : false;
  },
  methods: {
    //改变所有面板的状态
    closeAll() {
      this.$refs.baseInfo.closAbleHandler(true);
    },

    //查询部门id
    getDepartments() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/findCurrentAndSub",
          {
            token: token,
            data: {
              pageSize: -1
            }
          }
        )
        .then(response => {
          this.departments = response.data.data.departments;
          //计算出医院的全id路径
          if (this.form.majorDepartId) {
            let departIds = getCascaderFullValue(
              this.departments,
              this.form.majorDepartId
            );
            this.elementDeptId = departIds;
          }
        });
    },

    //拿到选择框选择的部门id
    handleDeptChange(value) {
      if (value != null) {
        this.elementDeptId = value;
        this.form.majorDepartId = value[value.length - 1];
      }
    },

    //拿到选择职称cd
    handleTitleTpCodeChange(value) {
      if (value != null) {
        this.form.showTitleTpCode = value;
        this.form.titleTpCode = value[value.length - 1];
      }
    },
    //第二职称拿到选择职称cd
    handleSecondTpCodeChange(value) {
      if (value != null) {
        this.form.showSecondTpCode = value;
        this.form.secondTpCode = value[value.length - 1];
      }
    },
    //拿到省份码表值
    handleCodeChange(value) {
      if (value && value.length > 0) {
        this.$refs.codeCascader.dropDownVisible = false;
        this.form.originProvinceCode = value[0];
        this.form.originCityCode = value.length > 1 ? value[1] : "";
      } else {
        this.form.originProvinceCode = "";
        this.form.originCityCode = "";
      }
    },

    //获取籍贯的回显值
    handlePCodeAndCCode() {
      let result = [];
      if (this.form.originCityCode) {
        result.push(this.form.originProvinceCode);
        result.push(this.form.originCityCode);
      } else {
        result.push(this.form.originProvinceCode);
      }
      this.pCodeAndCCode = result;
    },

    //获取证件类型回显值
    handleIdTypeCodes() {
      if (this.eimsCodes.length > 0) {
        this.eimsCodes.forEach(arr => {
          if (arr.tp == "007") {
            this.codes.idTypeCodes.push(arr);
          }
        });
      }
    },

    //根据身份证自动获取出生日期和性别
    getInfo(idCard) {
      if (this.form.idTypeCode == "007-001") {
        let flag = false;
        this.$refs["ruleForm"].validateField(["idNumber"], valid => {
          if (!(valid === "")) {
            flag = true;
          }
        });
        if (flag) {
          return;
        }
        let sex = null;
        let birth = null;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();

        if (idCard.length === 18) {
          sex = idCard.substring(16, 17);
          birth =
            idCard.substring(6, 10) +
            "-" +
            idCard.substring(10, 12) +
            "-" +
            idCard.substring(12, 14);
          if (
            idCard.substring(10, 12) < month ||
            (idCard.substring(10, 12) === month &&
              idCard.substring(12, 14) <= day)
          );
        } else if (idCard.length === 15) {
          sex = idCard.substring(13, 14);
          birth =
            "19" +
            idCard.substring(6, 8) +
            "-" +
            idCard.substring(8, 10) +
            "-" +
            idCard.substring(10, 12);
          if (
            idCard.substring(8, 10) < month ||
            (idCard.substring(8, 10) === month &&
              idCard.substring(10, 12) <= day)
          );
        } else {
          return;
        }
        if (sex % 2 === 0) {
          sex = "0"; // 1代表男，0代表女
        } else {
          sex = "1";
        }
        this.form.birth = birth;
        this.form.gender = sex;
      }
    },

    //点击编辑按钮
    handleEditClick() {
      this.isShowSee = false;
      this.isShowEdit = true;
      this.form.userId = this.showData.userId;
      this.form.name = this.showData.userName;
      this.form.gender = this.showData.gender;
      this.form.departmentId = this.showData.departmentId;
      this.form.tp = this.showData.tp;
      this.form.departmentName = this.showData.departmentName;
      this.form.pid = this.showData.pid;
      this.form.pname = this.showData.pname;
      this.form.birth = this.showData.birth;
      this.form.politicTpCode = this.showData.politicTpCode;
      this.form.administrative = this.showData.administrative;
      this.form.titleTpCode = this.showData.titleTpCode;
      this.form.secondTpCode = this.showData.secondTpCode;
      this.form.mail = this.showData.mail;
      this.form.tutorTpCode = this.showData.tutorTpCode;
      this.form.tutorObtainTime = this.showData.tutorObtainTime;
      this.form.directionLv1TpCode = this.showData.directionLv1TpCode;
      this.form.directionLv2TpCode = this.showData.directionLv2TpCode;
      this.form.directionLv2Desc = this.showData.directionLv2Desc;
      this.form.section = this.showData.section;
      this.form.idTypeCode = this.showData.idTypeCode;
      this.form.idNumber = this.showData.idNumber;
      this.form.idNumber2 =
        this.showData.idTypeCode == "007-002" ? this.showData.idNumber : null;
      this.form.wechatNumber = this.showData.wechatNumber;

      let itemB = this.codes["015"].find(
        item => item.cd == this.showData.titleTpCode
      );
      if (itemB) {
        let itemA = this.codes["014"].find(item => item.cd == itemB.parentCd);
        if (itemA) {
          let itemE = this.codes["062"].find(item => item.cd == itemA.parentCd);
          this.form.showTitleTpCode = [
            itemE.cd + "",
            itemA.cd + "",
            itemB.cd + ""
          ];
        }
      } else {
        this.form.showTitleTpCode = [this.showData.titleTpCode];
      }

      let itemC = this.codes["015"].find(
        item => item.cd == this.showData.secondTpCode
      );
      if (itemC) {
        let itemA = this.codes["014"].find(item => item.cd == itemC.parentCd);
        if (itemA) {
          let itemF = this.codes["062"].find(item => item.cd == itemA.parentCd);
          this.form.showSecondTpCode = [
            itemF.cd + "",
            itemA.cd + "",
            itemC.cd + ""
          ];
        }
      } else {
        this.form.showSecondTpCode = [this.showData.secondTpCode];
      }
    },
    //点击保存按钮
    handleSaveClick() {
      if (!this.validateFileForm()) {
        return false;
      }

      this.loadingData = true;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/personal/data/updateBaseInfo",
          {
            token: token,

            data: {
              userId: this.form.userId,
              userName: this.form.name,
              gender: this.form.gender,
              birth: this.form.birth,
              politicTpCode: this.form.politicTpCode,
              administrative: this.form.administrative,
              titleTpCode: this.form.titleTpCode,
              secondTpCode: this.form.secondTpCode,
              mail: this.form.mail,
              tutorTpCode: this.form.tutorTpCode,
              tutorObtainTime:
                this.form.tutorTpCode == "011-001"
                  ? null
                  : this.form.tutorObtainTime,
              directionLv1TpCode: this.form.directionLv1TpCode,
              directionLv2TpCode: this.form.directionLv2TpCode,
              directionLv2Desc: this.form.directionLv2Desc,
              section: this.form.section,
              idTypeCode: this.form.idTypeCode,
              wechatNumber: this.form.wechatNumber,
              idNumber: this.form.idTypeCode
                ? this.form.idTypeCode == "007-001"
                  ? this.form.idNumber
                  : this.form.idNumber2
                : null
            }
          }
        )
        .then(response => {
          if (response.data.code === "00000") {
            this.$message({
              message: "保存成功",
              showClose: true,
              type: "success"
            });
            this.handleCancelClick();
            this.getMemberBaseInfo();
            this.$store.dispatch("changeRefreshFlag", {
              baseFlag: true,
              headFlag: true
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    //点击取消按钮
    handleCancelClick() {
      this.isShowSee = true;
      this.isShowEdit = false;
      Object.assign(this.$data.form, this.$options.data().form);
    },

    //规则校验
    validateFileForm() {
      let result = false;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },

    //获取基本信息页面码值
    getBaseCodes() {
      let _this = this;
      _this.loadingData = true;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/code/getCodes/memberBasicCode",
          {
            token: token,
            data: {}
          }
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.codes = value.data.data;
            let bigTitleTpCode = this.codes["014"];
            let smallTitleTpCode = this.codes["015"];
            let exTitleTpCode = this.codes["062"];
            let titleTpCodes = [];
            let secondTpCodes = [];

            exTitleTpCode.forEach(item => {
              let bigChildren = [];
              bigTitleTpCode.forEach(itemA => {
                let children = [];
                smallTitleTpCode.forEach(itemB => {
                  if (itemB.parentCd === itemA.cd) {
                    children.push({ value: itemB.cd, label: itemB.cdDesc });
                  }
                });
                if (itemA.parentCd === item.cd) {
                  bigChildren.push({
                    value: itemA.cd,
                    label: itemA.cdDesc,
                    children: children.length === 0 ? null : children
                  });
                }
              });
              titleTpCodes.push({
                value: item.cd,
                label: item.cdDesc,
                children: bigChildren.length === 0 ? null : bigChildren
              });
              secondTpCodes.push({
                value: item.cd,
                label: item.cdDesc,
                children: bigChildren.length === 0 ? null : bigChildren
              });
            });

            this.titleTpCodes = titleTpCodes;
            this.secondTpCodes = secondTpCodes;
          }
        })
        .finally(() => {
          _this.loadingData = false;
          this.getMemberBaseInfo();
        });
    },

    getMemberBaseInfo() {
      let _this = this;
      _this.loadingData = true;
      let token = cookie.getCookie("token");

      http
        .post(window.config.api.baseUrl + "/eims-api/personal/data/baseInfo", {
          token: token,
          data: {
            userId: this.$store.state.MemberManageModule.userId
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            let userBaseInfo = response.data.data.userBaseInfo;
            this.showData.userId = userBaseInfo.userId;
            this.showData.userName = userBaseInfo.userName;
            this.showData.gender = userBaseInfo.gender;
            this.showData.departmentId = userBaseInfo.departmentId;
            this.showData.tp = userBaseInfo.tp;
            this.showData.departmentName = userBaseInfo.departmentName;
            this.showData.pid = userBaseInfo.pid;
            this.showData.pname = userBaseInfo.pname;
            this.showData.birth = userBaseInfo.birth;
            this.showData.politicTpCode = userBaseInfo.politicTpCode;
            this.showData.administrative = userBaseInfo.administrative;
            this.showData.titleTpCode = userBaseInfo.titleTpCode;
            this.showData.secondTpCode = userBaseInfo.secondTpCode;
            this.showData.mail = userBaseInfo.mail;
            this.showData.tutorTpCode = userBaseInfo.tutorTpCode;
            this.showData.tutorObtainTime = userBaseInfo.tutorObtainTime;
            this.showData.directionLv1TpCode = userBaseInfo.directionLv1TpCode;
            this.showData.directionLv2TpCode =
              userBaseInfo.directionLv2TpCode === undefined
                ? null
                : userBaseInfo.directionLv2TpCode;
            this.showData.directionLv2Desc = userBaseInfo.directionLv2Desc;
            this.showData.section = userBaseInfo.section;
            this.showData.idTypeCode = userBaseInfo.idTypeCode;
            this.showData.idNumber = userBaseInfo.idNumber;
            this.showData.wechatNumber = userBaseInfo.wechatNumber;
          }
        })
        .finally(() => {
          _this.loadingData = false;
        });
    },
    chooseLv1Value(newVal) {
      this.form.directionLv2TpCode = "";
      this.form.directionLv2Desc = "";
      // if (value==='012-999'){
      //   this.form.directionLv2TpCode = '013-9999'
      // }

      //一级研究方向的码表值
      let codes = this.codes["012"];
      if (codes) {
        for (let code of codes) {
          if (code.cd === newVal) {
            //如果一级选中其他
            if (code.cdDesc === "其他") {
              for (let code2 of this.codes["013"]) {
                if (code2.cdDesc === "其他") {
                  this.form.directionLv2TpCode = code2.cd;
                }
              }
              this.form.directionLv2 = "其他";
              //如果不是选择中其他
            } else {
              let code1 = this.codes["013"];
              for (let code1Element of code1) {
                if (code1Element.parentCd === code.cd) {
                  this.form.directionLv2TpCode = code1Element.cd;
                  break;
                }
              }
              this.form.directionLv2 = null;
            }
          }
        }
      }
    },
    chooseLv2Value(newVal) {
      let codes = this.codes["013"];
      if (codes) {
        for (let code of codes) {
          if (code.cd === newVal) {
            this.form.directionLv2 = code.cdDesc;
            break;
          }
        }
      }
      this.form.directionLv2Desc = null;
    }
  },

  created() {
    // this.$nextTick(args => {
    //   defaultLang.el.cascader.placeholder = "试试搜索：护士，或者选择"
    // })
    this.getDepartments();
    this.getBaseCodes();
  },

  computed: {
    ...mapState({
      eimsCodes: state => state.codeDictModule.eimsCodes,
      codesTree: state => state.codeDictModule.codesTree
    })
  }
};
</script>

<style scoped>
.member-button > button {
  border-radius: 5px;
  padding: 10px 35px;
  font-size: 16px;
}

.save-button {
  border: #34c5e7 1px solid;
  background-color: #34c5e7;
  color: #ffffff;
}

.save-button:hover {
  background-color: #2da3bf;
}

.save-button:active {
  background-color: #26849a;
}

.cancel-button {
  border: #34c5e7 1px solid;
  background-color: #ffffff;
  color: #34c5e7;
  font-size: 16px;
  margin-left: 40px;
}

.cancel-button:hover {
  background-color: #efefef;
}

.cancel-button:active {
  background-color: #e5e5e5;
}

.span-all {
  display: -webkit-box;
  margin-top: 25px;
}

.span-all .span-left {
  /*float: left;*/
  color: #999999;
  width: 120px;
  text-align-last: justify;
}

.span-all .span-right {
  margin-left: 10px;
  word-break: break-all;
  width: calc(100% - 130px);
}

/*如果位置出现了错位的问题,可以加上clear:both;解决*/
.member-right-inner-bottom {
  clear: both;
}

/deep/
  .deptClass
  .el-input.el-input--suffix
  input.el-input__inner::placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/memberData/memberBasic/Basic.vue